function getOffsetSum(elem, stopElem) {
    var top = 0, left = 0, curElem = elem;
    while (curElem) {
        top = top + curElem.offsetTop;
        left = left + curElem.offsetLeft;
		curElem = curElem.offsetParent;
		if (curElem === stopElem) {
			break;
		}
	}
    return {top: top, left: left};
}

module.exports =  getOffsetSum;